import React from "react";
import { Fragment, FragmentModal, message } from "@gw/web-basic-components";
import type { AccountSettingModalProps } from "./dto";
import { AccountInfo, ModifyAvatar, ModifyPassword } from "..";
import { useTranslation } from "react-i18next";
import { useRequest, apis } from "../../../../utils";
import configCenter from "@gw/odm-db";

const { entryConfig } = configCenter;
/**
 * 账号设置Modal
 */
const AccountSettingModal = (props: AccountSettingModalProps) => {
  const { t } = useTranslation();

  const [, fetchLogOut] = useRequest(apis.user.logout);

  /**
   * 登录密码修改后回调
   */
  const onModifySuccess = async () => {
    message.loading("即将返回门户重新登录……");
    await fetchLogOut();
    location.replace(entryConfig.login);
  };

  return (
    <FragmentModal
      className={`${props.appCode}-profile-modal`}
      open={props.open}
      onCancel={props?.onClose}
      destroyOnClose
    >
      <Fragment
        name="accountInfo"
        title={props.isI18N ? t("account_settings") : "账户设置"}
        component={() => (
          <AccountInfo
            isI18N={props.isI18N}
            useInfo={props.useInfo}
            appCode={props.appCode}
          />
        )}
      />
      <Fragment
        name="modifyAvatar"
        title={props.isI18N ? t("modify_avatar") : "修改头像"}
        component={(p) => (
          <ModifyAvatar
            isI18N={props.isI18N}
            avatarCode={props.useInfo?.avatarCode}
            avatarFileUrl={props.useInfo?.avatarFileUrl}
            {...p}
            appCode={props.appCode}
          />
        )}
      />
      <Fragment
        name="modifyPassword"
        title={props.isI18N ? t("change_password") : "修改密码"}
        component={(p) => (
          <ModifyPassword
            {...p}
            appCode={props.appCode}
            isI18N={props.isI18N}
            api={apis.account.reset}
            useRequest={useRequest}
            onSuccessfull={() => onModifySuccess()}
          />
        )}
      />
      <Fragment
        name="modifyKeyPassword"
        title={props.isI18N ? t("change_password") : "修改关键操作步骤密码"}
        component={(p) => (
          <ModifyPassword
            {...p}
            appCode={props.appCode}
            isI18N={props.isI18N}
            useRequest={useRequest}
            api={apis.keyStepPassword.reset}
          />
        )}
      />
    </FragmentModal>
  );
};

export default AccountSettingModal;
